import {CookieReport} from '@/modules/page/components/content-blocks/cookie-report';

import type {CookieReportFragment} from './query';

type Props = {
	data: CookieReportFragment;
};

export const CookieReportContainer = ({data}: Props) => {
	return (
		<CookieReport
			spacingBottom={data.layout?.spacingBottom}
			spacingTop={data.layout?.spacingTop}
		/>
	);
};
